export enum ResizeDirection {
    N = 'N',
    S = 'S',
    E = 'E',
    W = 'W',
    NE = 'NE',
    NW = 'NW',
    SE = 'SE',
    SW = 'SW',
}
